<ng-template #templateLeft>
    <p-button icon="pi pi-arrow-left" (click)="prevPage()" [rounded]="true" [text]="true"></p-button>
  </ng-template>
  <ng-template #templateRight>
    <p-button icon="pi pi-arrow-right" (click)="nextPage()" [rounded]="true" [text]="true"></p-button>
  </ng-template>
  <p-paginator [templateLeft]="templateLeft"  [templateRight]="templateRight" class="paginator-custom-1" (onPageChange)="onPageChange($event)" [first]="1" [rows]="5" [totalRecords]="50"></p-paginator>